import { render } from "./CookiesSetting.vue?vue&type=template&id=9fde2642&scoped=true"
import script from "./CookiesSetting.vue?vue&type=script&lang=js"
export * from "./CookiesSetting.vue?vue&type=script&lang=js"

import "./CookiesSetting.vue?vue&type=style&index=0&id=9fde2642&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fde2642"]])

export default __exports__